import { Route, Routes } from "react-router-dom";
import './App.css';
import LandingPage from "./pages/LandingPage";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Resource from "./pages/Resource";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getProfileAPI } from "./redux/auth/slice";

function App() {

  const dispatch = useDispatch();


  const { getProfileData } = useSelector((state) => state.auth);

  return (
    <Routes>
      {/* Authentication routes */}
      <Route path="/" element={<LandingPage getProfileData={getProfileData} />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup/:id" element={<Signup />} />
      <Route path="/resources" element={<Resource getProfileData={getProfileData} />} />
    </Routes>
  );
}

export default App;
